/**
 * CertificateGrid
 * Grid component for displaying certificates with download actions
 */

import React from 'react';
import { Button } from 'react-bootstrap';
import { Download } from 'react-bootstrap-icons';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import { CertificateResponseDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import momencik from '../../../common/momencik';

export const certificateForGrid = (
  cert: CertificateResponseDto,
  onDownload?: (cert: CertificateResponseDto) => void,
): GridRecord => {
  return {
    key: cert.id || '',
    values: {
      'certificates.commonName': cert.commonName || '',
      'certificates.type': cert.type || '',
      'certificates.status': cert.status || '',
      'certificates.issuedAt': momencik(cert.issuedAt),
      'certificates.expiresAt': momencik(cert.expiresAt),
      'certificates.serialNumber': cert.serialNumber || '',
      download: cert.id ? (
        <Button
          variant="link"
          size="sm"
          onClick={e => {
            e.stopPropagation();
            if (cert.id) {
              onDownload?.(cert);
            }
          }}
        >
          <Download />
        </Button>
      ) : null,
    },
  };
};

const columns: GridColumn[] = [
  { header: 'Nazwa podmiotu', property: 'certificates.commonName' },
  { header: 'Typ', property: 'certificates.type' },
  { header: 'Status', property: 'certificates.status' },
  { header: 'Data wydania', property: 'certificates.issuedAt' },
  { header: 'Data wygaśnięcia', property: 'certificates.expiresAt' },
  { header: 'Numer seryjny', property: 'certificates.serialNumber' },
  { header: '', property: 'download', noSorting: true, noFilter: true },
];

interface CertificateGridProps {
  getData: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
  ) => Promise<GridRecord[]>;
  getDataCount: () => Promise<number>;
  refresh: boolean;
}

export const CertificateGrid: React.FC<CertificateGridProps> = ({
  getData,
  getDataCount,
  refresh,
}) => {
  return (
    <div className="table-responsive">
      <Grid
        getData={getData}
        getDataCount={getDataCount}
        columns={columns}
        showFilter={true}
        initialOrderColumn="certificates.issuedAt"
        initialOrderDirection="DESC"
        availablePageSizes={[10, 20, 50]}
        emptyGridMessage="Brak certyfikatów"
        refresh={refresh}
      />
    </div>
  );
};
